<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">default header</slot>
          </div>

          <div class="modal-body">
            <slot name="body">default body</slot>
          </div>

          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import TwBtn from "../tw-btn";

export default {
  name: "verify-sms",
  components: {
    TwBtn
  }
};
</script>

<style lang="less" scope>
.modal-mask {
  position: fixed;
  display: flex;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
  border-radius: 0.5rem;
}

.modal-wrapper {
  position: relative;
  display: flex;
  width: 100%;
}

.modal-container {
  width: 30rem;
  margin: auto;
  // padding: 20px 30px;
  background-color: #dfe6e9;
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  // font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  border-radius: 1rem 1rem 0rem 0rem;
  padding-top: 1rem;
  padding-bottom: 0.5rem;
  // margin-top: 1.5rem;
  text-align: center;
  letter-spacing: 12px;
  font-size: 1.5rem;
  background-color: rgba(0, 0, 0, 0.1);
}

.modal-body {
  margin: 20px 0;
  display: flex;
  width: 100%;
}

.modal-footer {
  margin-bottom: 1.5rem;
  display: flex;
  padding: 1rem;
  width: 100%;

  .button {
    display: flex;
    width: 100%;
    justify-content: space-around;
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/lease/VerifySMS.vue